import { chain } from '$lib/wallet/store';
import type { SendTransactionResult } from '@wagmi/core';
import { waitForTransaction } from '@wagmi/core';
import { get } from 'svelte/store';
import { notifications } from './store';

const API_FAILURE_NOTIF_ID = 1234567;

function getRandomNotifId() {
	return (Math.random() * 1000000).toFixed();
}

export async function addTransactionNotification(
	title: string,
	description: string,
	tx: SendTransactionResult,
	onSuccessHandler: (() => void) | undefined = undefined,
	onFailureHandler: (() => void) | undefined = undefined
) {
	let allNotificationsToAdd = get(notifications);
	let notifId = getRandomNotifId();
	allNotificationsToAdd[notifId] = {
		title: 'Transaction Submitted',
		description: 'Transaction has been submitted and waiting for confirmation.',
		type: 'Pending',
		transaction: tx
	};
	notifications.set(allNotificationsToAdd);

	const res = await waitForTransaction({
		chainId: get(chain)?.id,
		hash: tx.hash
	});

	let allNotifications = get(notifications);
	delete allNotifications[notifId];
	notifications.set(allNotifications);

	if (res.status == 'success') {
		if (onSuccessHandler) onSuccessHandler();
		//transaction succeeded.
		addTransactionSuccessfulNotification(title, description, tx);
	} else {
		//something went wrong
		if (onFailureHandler) onFailureHandler();
		console.log(res);
		throw {
			name: 'Transaction failed',
			message: 'Transaction could not be processed. Tx hash: ' + tx.hash
		};
	}
}
export async function addTransactionSuccessfulNotification(
	title: string,
	description: string,
	tx: SendTransactionResult | undefined = undefined
) {
	let allNotificationsToAdd = get(notifications);
	let notifId = getRandomNotifId();
	allNotificationsToAdd[notifId] = {
		title: title,
		description: description,
		type: 'Success',
		transaction: tx
	};
	notifications.set(allNotificationsToAdd);
	let notificationeleteTimeOut = 10000;
	setTimeout(function () {
		let allNotificationsToRemove = get(notifications);
		delete allNotificationsToRemove[notifId];
		notifications.set(allNotificationsToRemove);
	}, notificationeleteTimeOut);
}

export async function addErrorNotification(
	title: string,
	description: string,
	fullError: string,
	apiFailure: boolean = false
) {
	let allNotificationsToAdd = get(notifications);
	let notifId = apiFailure ? API_FAILURE_NOTIF_ID : getRandomNotifId();
	if (notifId in allNotificationsToAdd) return;
	if (description && String(description).includes('User rejected the request.')) {
		allNotificationsToAdd[notifId] = {
			title: 'User rejected the request.',
			description: 'Request was rejected by the user',
			type: 'Error',
			fullError
		};
	} else {
		allNotificationsToAdd[notifId] = {
			title: title,
			description: description,
			type: 'Error',
			fullError
		};
	}
	notifications.set(allNotificationsToAdd);
	let notificationeleteTimeOut = 12000;
	setTimeout(function () {
		let allNotificationsToRemove = get(notifications);
		delete allNotificationsToRemove[notifId];
		notifications.set(allNotificationsToRemove);
	}, notificationeleteTimeOut);
}

export async function addPendingNotification(title: string, description: string) {
	let allNotificationsToAdd = get(notifications);
	let notifId = getRandomNotifId();
	allNotificationsToAdd[notifId] = { title: title, description: description, type: 'Error' };
	notifications.set(allNotificationsToAdd);
	let notificationeleteTimeOut = 3000;
	setTimeout(function () {
		let allNotificationsToRemove = get(notifications);
		delete allNotificationsToRemove[notifId];
		notifications.set(allNotificationsToRemove);
	}, notificationeleteTimeOut);
}

export function hideNotification(notifId: string) {
	let allNotificationsToRemove = get(notifications);
	delete allNotificationsToRemove[notifId];
	notifications.set(allNotificationsToRemove);
}
